module.exports = __webpack_public_path__ + "img/fr_failure_4.80535a97.png";